import { useQuery } from "@tanstack/react-query";
import { PageLoader } from "components";
import queryString from "query-string";
import { client_v2 } from "utils/api";

const ProductsFindByCode = ({ history, location }) => {
  const { code } = queryString.parse(location.search);

  useQuery(
    ["search", code],
    () => client_v2.get(`/products/find_by_code?code=${code}`),
    {
      select: (res) => res.data,
      retry: false,
      onSuccess: ({ id }) => {
        history.push(`/products/${id}/basic`);
      },
      onError: (err) => {
        console.log(err);
        history.push("/products");
      },
    }
  );
  return <PageLoader />;
};

export default ProductsFindByCode;
